import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setActiveUpgradeStepCheckout } from '../modules/active_upgrade_step';
import { unSoftUpgradePositiveMember } from '../modules/membership_actions';
import { closeModal } from '../modules/active_modal';

class UpgradeAcceptTerms extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isShowing:       false,
      customer:         {},
      shipping_address: {},
    };
    this.toggleShowingState = this.toggleShowingState.bind(this);
    this.enrollAcceptTerms  = this.enrollAcceptTerms.bind(this);
  }

  enrollAcceptTerms( dispatch, evt ) {
    evt.preventDefault();
  }

  toggleShowingState() {
    this.setState({isShowing: !this.state.isShowing });
  }

  cancelUpgrade(){
    if(this.props.customer.fulfillment_type === "Positive") this.props.dispatch( unSoftUpgradePositiveMember() );
    else this.props.dispatch( closeModal());
  }

  render() {
    let { dispatch } = this.props;

    return(
       <div className="info-edit-form half-col showing upgrade-terms">
        <h2>Upgrade your membership today!</h2>
        <div className="col-20"><div className="imageContainer fs" /></div>
        <div className="col-80">
          <h3>Featured Selections</h3>
          <h4>{"On the 1st of each month, you'll recieve a Featured Selections email highlighting the best new books for readers like you."}</h4>
        </div>
        <div className="col-20" ><div className="imageContainer credits" /></div>
        <div className="col-80">
          <h3>Member Credits</h3>
          <h4>{'Visit the site between the 1st and the 10th and press "Buy Now" to purchase your Member Credits. Use them right away or save them for later. They never expire!'}</h4>
        </div>
        <div className="col-20" ><div className="imageContainer skip" /></div>
        <div className="col-80">
          <h3>Skip Any Month</h3>
          <h4>{'If you don\'t want your monthly Member Credits, visit the site and click "SKIP" by the 10th of the month. If you don\'t click "SKIP", we will automatically purchase your credits for you using your credit card on file.'}</h4>
        </div>
        <button className="btn-primary full-width fat"
          onClick={() => dispatch(setActiveUpgradeStepCheckout())} > Upgrade Now!</button>
        <button className="btn-secondary full-width fat"
          onClick={this.cancelUpgrade.bind(this)} >No Thanks, Continue without upgrading</button>
      </div>

    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'tla' : state.store.tla
    };
}

export default connect(mapStateToProps)(UpgradeAcceptTerms);



// WEBPACK FOOTER //
// ./src/components/UpgradeAcceptTerms.jsx